import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { ItemList } from "../../../../components/modules/Consents/components/ItemList.js";
const OptInsContainer = ({
  isLoggedIn,
  isCreateAccountEnabled,
  onChange,
  selectedOptIns,
  optIns,
  isImplicitAccountCreation,
  isMyAccountEnabled
}) => {
  const { getFormattedLabel } = useIntl();
  const getItemLabel = React.useCallback(
    (item) => getFormattedLabel(item.titleKey, {
      parseHTML: true
    }),
    [getFormattedLabel]
  );
  const shouldIndent = React.useMemo(
    () => !isLoggedIn && isCreateAccountEnabled && !isImplicitAccountCreation,
    [isImplicitAccountCreation, isLoggedIn, isCreateAccountEnabled]
  );
  const getItemIdentifier = React.useCallback(
    (item) => item.titleKey,
    []
  );
  if (!optIns.length || isMyAccountEnabled && !isLoggedIn && !isCreateAccountEnabled) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    ItemList,
    {
      getItemIdentifier,
      getItemLabel,
      idPrefix: "opt-ins__",
      items: optIns,
      onChange,
      selectedItems: selectedOptIns,
      shouldIndent
    }
  );
};
export {
  OptInsContainer
};
//# sourceMappingURL=OptInsContainer.js.map
